var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#DBFFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H10.7778C10.3063 11 9.8541 11.1873 9.5207 11.5207C9.1873 11.8541 9 12.3063 9 12.7778V25.2222C9 25.6937 9.1873 26.1459 9.5207 26.4793C9.8541 26.8127 10.3063 27 10.7778 27H23.2222C23.6937 27 24.1459 26.8127 24.4793 26.4793C24.8127 26.1459 25 25.6937 25 25.2222V19",
    stroke: "#00D681",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6662 9.57198C24.0325 9.20575 24.5292 9 25.0471 9C25.5651 9 26.0618 9.20575 26.428 9.57198C26.7943 9.93822 27 10.4349 27 10.9529C27 11.4708 26.7943 11.9675 26.428 12.3338L17.6824 21.0794L14 22L14.9206 18.3176L23.6662 9.57198Z",
    stroke: "#00D681",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8daac66a103b42c62c5c44ee2a8872c8.svg";
export { ForwardRef as ReactComponent };